import { render, staticRenderFns } from "./MessagesBtn.vue?vue&type=template&id=3178dcac&"
import script from "./MessagesBtn.vue?vue&type=script&lang=js&"
export * from "./MessagesBtn.vue?vue&type=script&lang=js&"
import style0 from "./MessagesBtn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports